var React = require('react');

function Left (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.5 1.2334L2 17.7334L18.5 34.2334","stroke":"#C9C9CC","strokeWidth":"3","strokeLinejoin":"round"}));
}

Left.defaultProps = {"width":"20","height":"36","viewBox":"0 0 20 36","fill":"none"};

module.exports = Left;

Left.default = Left;
